/**
 * @module websocket.event.handlers.airlines.airline-deleted
 */
import { store } from '../../../../state/store'
import { setAirlineListUpdated } from '../../../../state/websocket.slice'

export default function handleAirlineDeleted(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAirlineDeleted', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAirlineListUpdated(data))
  }
} 